import React from 'react';
import { ArrowRight } from 'lucide-react';
import Navbar from '../components/Navbar.jsx';
import Footer from '../components/Footer.jsx';
import Seo from '../components/Seo.jsx';

export default function NotFound() {
  return (
    <div style={{ fontFamily: "'Inter', sans-serif", background: '#FFFFFF', minHeight: '100vh' }}>
      <Seo title="Page Not Found" noindex />
      <Navbar />
      <section style={{
        minHeight: '70vh', display: 'flex', flexDirection: 'column',
        alignItems: 'center', justifyContent: 'center', textAlign: 'center',
        padding: '150px 1.5rem 5rem',
      }}>
        <span style={{
          fontFamily: "-apple-system, BlinkMacSystemFont, 'SF Pro Display', 'Helvetica Neue', Arial, sans-serif",
          fontSize: 'clamp(4rem, 12vw, 7rem)', fontWeight: '800', color: '#E8672E', lineHeight: 1,
        }}>
          404
        </span>
        <h1 style={{
          fontFamily: "-apple-system, BlinkMacSystemFont, 'SF Pro Display', 'Helvetica Neue', Arial, sans-serif",
          fontSize: 'clamp(1.5rem, 3vw, 2rem)', fontWeight: '700', color: '#17140F',
          margin: '0.5rem 0 0.75rem',
        }}>
          This page had one too many
        </h1>
        <p style={{ color: '#6B665C', fontSize: '1rem', maxWidth: '420px', margin: '0 0 2rem', lineHeight: 1.7 }}>
          We couldn't find the page you're looking for. It might have moved, or never existed.
        </p>
        <a href="/" style={{
          display: 'inline-flex', alignItems: 'center', gap: '0.5rem',
          background: '#E8672E', color: 'white', textDecoration: 'none',
          borderRadius: '50px', padding: '0.85rem 2rem', fontSize: '0.9rem', fontWeight: '700',
        }}>
          Back to Home <ArrowRight size={16} />
        </a>
      </section>
      <Footer />
    </div>
  );
}
